import React, { createContext, useContext, useRef } from "react";

type ClientChangeContextT = {
  isClientChangingRef: React.MutableRefObject<boolean>;
  setClientChanging: (v: boolean) => void;
};

const ClientChangeContext = createContext<ClientChangeContextT | null>(null);

export function ClientChangeProvider({ children }: { children: React.ReactNode }) {
  const isClientChangingRef = useRef<boolean>(false);

  const setClientChanging = (v: boolean) => {
    isClientChangingRef.current = v;
  };

  const value = { isClientChangingRef, setClientChanging };

  return <ClientChangeContext.Provider value={value}>{children}</ClientChangeContext.Provider>;
}

export function useClientChangeState() {
  const ctx = useContext(ClientChangeContext);
  if (!ctx) throw new Error("useClientChangeState must be used within ClientChangeProvider");
  return ctx;
}
